import BecomeMember from './BecomeMember'

export default BecomeMember;
